import { ChatMemberSchema, UserShortSchema } from 'constants/graphqlTypes';

export const getChatMembers = (members: ChatMemberSchema[]): UserShortSchema[] =>
  members?.reduce(
    (chatMembers: UserShortSchema[], chatMember) =>
      chatMember?.user ? [...chatMembers, chatMember.user] : chatMembers,
    []
  ) ?? [];
